import { CustomerUserPermission } from "@/features/clients/clients.interfaces";
import { Status } from "@/features/projectRegister/projectRegister.interfaces";
import { EOption } from "@/features/projectRegister/projectRegister.types";
import { Action, UserAccessList, Permissions } from "@/interfaces/globals";

export interface LabelValue {
  label: string;
  value: string;
  isInactive?: boolean;
}

export type Options = {
  id: string;
  label: string;
};

export type FullName = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
};

export interface Address {
  latitude: string;
  longitude: string;
  postalCode?: string;
  radius?: string;
  label?: string;
  areaLocation?: string;
}

export enum Roles {
  SUPER_ADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
}
export interface UserProps {
  id: string;
  firstName: string;
  middleName?: string;
  phoneNumber?: string;
  lastName?: string;
  company: string | null;
  role: Roles;
  email: string;
  token: string;
  image: string;
  permissions:
    | [
        {
          action: string;
          resource: string;
          workspace?: string;
          customer?: string;
        },
      ]
    | CustomerUserPermission;
  userAccessList: UserAccessList;
  unViewedNotifications: number;
}
export interface customerPermission {
  emailNotification: boolean;
  customerPortal: boolean;
  projectFinance: boolean;
  workDocket: boolean;
}
export interface customerUser {
  id?: string;
  name: string;
  image: string;
  email: string;
  position: string;
  role: string;
  firstName: string;
  status: Status;
  middleName?: string;
  lastName: string;
  customerId?: string;
  permissions?: customerPermission;
  user?: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    role: string;
  };
}

export interface Workspace {
  id: string;
  name: string;
  abn: string;
  logo?: string;
  email: string;
  phoneNumber: string;
  state: string;
  subDomain: string;
  createdAt: string;
  updatedAt: string;
  permissionsId?: string | null;
  userAccessListId?: string | null;
  isSyncedWithXero: boolean;
}

export interface PermissionsResponse {
  actions: Action[];
  resources: { [key: string]: Permissions[] };
}

export interface Workspace {
  id: string;
  companyName: string;
}

export interface SubContractorEntity {
  id: string;
  name: string;
  image: string;
  email: string;
  phoneNumber: string;
  accountEmail: string;
  addressLat: string;
  addressLon: string;
  abn: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  status: "ACTIVE" | "INACTIVE";
  address: {
    label: string;
    latitude: string;
    longitude: string;
  };
  workspace?: Workspace;
  workspaceId: string;
}

export interface RecoveryBreakDown {
  [x: string]: {
    loadType: string;
    wasteType: string;
    loadQuantity: number;
    netWasteWeight: number;
    totalWasteWeight: number;
    recycledMaterials: string[];
  };
}

export interface TRecoveryPathway {
  REUSE?: number;
  RECYCLE?: number;
  LANDFILL?: number;
  HAZARDOUS?: number;
}

export interface TRecyclingPercentage {
  recyclingPercentage: number;
  nonRecyclingPercentage: number;
}

export type DayOfWeek =
  | "Sunday"
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday";

export type ButtonVariant =
  | "link"
  | "default"
  | "destructive"
  | "outline"
  | "secondary"
  | "ghost"
  | "light";

export type AllowedExportFileTypes = "csv" | "pdf" | "txt" | "xlsx";

export type NewOptions<T> = Omit<EOption, "for"> & {
  for: T;
};

enum NotificationType {
  LOGIN = "LOGIN",
  SIGNUP = "SIGNUP",
}

export interface NotificationView {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: NotificationType;
  content: string;
  employeeId: string;
  workspaceId: string;
  employee: {
    id: string;
    user: {
      firstName: string;
      middleName?: string;
      lastName: string;
    };
  };
}
export interface Notification {
  createdAt: string;
  updatedAt: string;
  userId: string;
  notificationId: string;
  isRead: boolean;
  notification: NotificationView;
}
